export const getLetterSpacingList = () => {
  const whitelist = []
  for(let i = -1000; i <= 1000; i++){
    const style = (i / 1000) + 'em'
    whitelist.push(style)
  }
  return whitelist
}

export const getFontSizeList = () => {
  const whitelist = []
  for(let i = 0; i <= 1000; i++){
    whitelist.push(i + 'px')
  }
  return whitelist
}

export const getOpacityRange = () => {
  const whitelist = []
  for(let i = -1; i <= 100; i++){
    whitelist.push(i/100)
  }
  return whitelist
}

export const getLineHeightRange = () => {
  const wl = []
  for(let i = 0; i <= 1000; i++){
    wl.push(i / 100)
  }
  return wl
}

export const getShapesList = () => {
  return [
    '1-ring.svg',
    '2-triangle.svg',
    '3-ruut.svg',
    '101-empty-circle.svg',
    '100-empty-square.svg',
    '10-arrow-UP.svg',
    '11-arrow-NW.svg',
    '12-arrow-NE.svg',
    '13-arrow-right.svg',
    '14-arrow-left.svg',
    '15-arrow-down.svg',
    '16-arrow-left.svg',
    '17-arrow-right.svg',
    '18-arrow-SW.svg',
    '19-arrow-SE.svg',
    '20-arrow-down.svg',
    '21-clip.svg',
    '22-speech.svg',
    '23-speech-rect.svg',
    '24-speech.svg',
    '25-speech.svg',
    '26.svg',
    '27-speech.svg',
    '28-film.svg',
    '29-calc.svg',
    '30-X.svg',
    '31-cart.svg',
    '32-yin.svg',
    '33-brief.svg',
    '34-flag.svg',
    '35-tools.svg',
    '36-people.svg',
    '37-man.svg',
    '38-people.svg',
    '39-pc.svg',
    '4-rectangle.svg',
    '40-clock.svg',
    '41-exit.svg',
    '42-house.svg',
    '43-HDD.svg',
    '44-files.svg',
    '45-document.svg',
    '46-signed.svg',
    '47-scissors.svg',
    '48-clock.svg',
    '49-zoom.svg',
    '5-hexagon.svg',
    '50-zoom-out.svg',
    '51-expand.svg',
    '52-cart.svg',
    '53-letter.svg',
    '54-income-mail.svg',
    '55-mail.svg',
    '56-mail.svg',
    '57-star.svg',
    '58-star2.svg',
    '59-bar.svg',
    '6-arrow-right.svg',
    '60-sign.svg',
    '61-OFF.svg',
    '62-no-parking.svg',
    '63-nuclear.svg',
    '64-upload.svg',
    '65-shapes.svg',
    '66-world.svg',
    '67-bulb.svg',
    '68-cross.svg',
    '69-heart.svg',
    '7-arrow-left.svg',
    '70-hand.svg',
    '71-finger.svg',
    '72-DOWNLOAD.svg',
    '73-cycle.svg',
    '74-chain.svg',
    '75-tag.svg',
    '76-airplane.svg',
    '77-recycle.svg',
    '78-network.svg',
    '79-key.svg',
    '8-arrow-W.svg',
    '80-locked.svg',
    '81-computer.svg',
    '82-circle-arrow.svg',
    '83-tick.svg',
    '84-wifi.svg',
    '85-printer.svg',
    '86-printer2.svg',
    '87-audio.svg',
    '88-audio-off.svg',
    '89-audio-add.svg',
    '9-arrow-E.svg',
    '90-audio-off.svg',
    '91-wind.svg',
    '92-end.svg',
    '93-pause.svg',
    '94-play.svg',
    '95-stop.svg',
    '96-beginning.svg',
    '97-beginning.svg',
    '98-rounded-edge-rectangle.svg',
  ]
}